import { render, staticRenderFns } from "./AppliedDocCountByOrganization.vue?vue&type=template&id=6ec77526&scoped=true&"
import script from "./AppliedDocCountByOrganization.vue?vue&type=script&lang=js&"
export * from "./AppliedDocCountByOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec77526",
  null
  
)

export default component.exports